import dynamic from 'next/dynamic';

// Types
import type { UserPublicTokenType } from '@/utils/hooks/swr/integrations/useUserPublicTokens';
import useUserPublicTokens from '@/utils/hooks/swr/integrations/useUserPublicTokens';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Hooks
import useToggle from '@/utils/hooks/utils/useToggle';

// Lib
import { USER_PUBLIC_TOKENS } from '@/lib/routes/apiEndpoints';

// Components
import Icon from '@/components/base/Icon';
const DeleteModal = dynamic(() => import('@/components/composite/Modals/DeleteModal'));

type ButtonDeleteTokenProps = {
    token: UserPublicTokenType;
};

function ButtonDeleteToken({ token }: ButtonDeleteTokenProps) {
    const { t } = useTranslation('integrations');
    const { isOpen, toggle } = useToggle();
    const { mutateUserPublicTokens } = useUserPublicTokens({
        options: { revalidateIfStale: false }
    });

    return (
        <>
            <button
                className="inline-flex items-center"
                data-testid={`delete-token-${token.id}`}
                onClick={toggle}>
                <Icon
                    icon="trash"
                    className="text-sm text-icoGray-500 dark:text-icoDarkMode-wolf"
                />
            </button>
            <DeleteModal
                isOpen={isOpen}
                toggle={toggle}
                title={t('api_access.delete_key_modal.title')}
                description={t('api_access.delete_key_modal.description')}
                apiUrl={`${USER_PUBLIC_TOKENS}/${token.id}`}
                callbackSuccess={async () => await mutateUserPublicTokens()}
            />
        </>
    );
}

export default ButtonDeleteToken;
